<template>
  <transition
    appear
    appear-active-class="popup-input--appearing"
    appear-class="popup-input--appeared"
    name="appearing"
  >
    <div @click.self="close()" class="popup-input" v-if="show">
      <div class="popup-input__window">
        <div class="popup-input__label">{{label}}</div>
        <div @click="close()" class="popup-input__close"/>

        <template v-if="variant === 'purchise'">
          <div class="popup-input__controls">
            <default-range-input
              v-if="amount"
              :max="amount.max"
              :measure="measure"
              :min="amount.min"
              :step="amount.step"
              :value="amount.value"
              @input="setIngredientAmount([name, $event])"
              class="popup-input__range popup-input__amount"
              :label="$t('message.for1CubicMeter')"
            />

            <default-range-input
              :currency="result.currency"
              :max="price.max"
              :measure="price.measure"
              :min="price.min"
              :purchase="purchase"
              :step="price.step"
              :value="price.value"
              @input="setIngredientPrice([name, $event])"
              class="popup-input__range popup-input__price"
              :label="$t('message.cost')"
            />

          </div>
          <div class="popup-input__summary">
            <div class="popup-input__summary-header">
              {{ $t('message.spendsFor', { period: $tc('plural.day', period) }) }}
            </div>
            <div class="popup-input__summary-amount">
              <value :measure="purchase.measure" :num="consumption / purchase.multiplier"/>
            </div>
            <div class="popup-input__summary-price">
              <price :currency="result.currency" :num="sum"/>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="popup-input__controls">
            <default-range-input
              :currency="result.currency"
              :max="price.max"
              :min="price.min"
              :purchase="purchase"
              :step="price.step"
              :value="price.value"
              @input="setIngredientPrice([name, $event])"
              class="popup-input__range popup-input__price"
              :label="$t('message.for1CubicMeter')"
            />
          </div>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
  import DefaultRangeInput from "../DefaultRangeInput";
  import declOfNum from "../../mixins/declOfNum";
  import Value from "../Value";
  import Price from "../Price";
  import {mapActions, mapGetters} from "vuex";

  export default {
    name: "PopupInput",
    components: {Price, Value, DefaultRangeInput},
    mixins: [
      declOfNum
    ],
    props: {
      variant: {
        type: String,
        default: 'purchise',
        validate: (val) => ['purchise', 'price'].includes(val)
      },
      setAmount: {
        type: Function,
        default: (val) => val
      },
      setPrice: {
        type: Function,
        default: (val) => val
      },
      show: {
        type: Boolean,
        default: false
      },
      name: {
        type: String,
        default: ''
      },
      measure: {
        type: String,
        default: 'шт'
      },
      label: {
        type: String,
        default: ''
      },
      period: {
        type: Number,
        default: 0
      },
      consumption: {
        type: Number,
        default: 0
      },
      sum: {
        type: Number,
        default: 0
      },

      purchase: {
        type: Object,
        default: () => ({})
      },
      amount: {
        type: Object,
        default: () => ({
          value: 0,
          min: 0,
          max: 1,
          step: 1,
          measure: 'шт.'
        })
      },
      price: {
        type: Object,
        default: () => ({
          value: 0,
          min: 0,
          max: 1,
          step: 1,
          currency: {
            symbol: '#'
          }
        })
      }
    },
    data() {
      return {
        isShown: false
      }
    },
    computed: {
      ...mapGetters('mobile', [
        'hideChange', 'result'
      ])
    },
    methods: {
      ...mapActions('mobile', [
        'setIngredientAmount', 'setIngredientPrice'
      ]),
      open() {
        this.isShown = true;
      },
      close() {
        this.isShown = false;
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .popup-input {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 1em;
    z-index: 600;

    &__window {
      position: relative;
      padding: 1.125em;
      border-radius: 3px;
      background-color: #ffffff;
      box-shadow: 0 16px 24px rgba(1, 1, 0, 0.5);
    }

    &__label {
      line-height: 2.222222222222222em;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-style: normal;
      font-weight: normal;
      font-size: 1.125em;
    }

    &__close {
      display: flex;
      position: absolute;
      top: 1.125em;
      right: 1.125em;
      width: 2.5em; // 40px
      height: 2.5em; // 40px
      cursor: pointer;

      &::before {
        content: '';
        display: block;
        width: 0.75em;
        height: 0.75em;
        margin: auto;
        background-image: url("../../assets/close.svg");
        background-repeat: no-repeat;
        background-size: contain;
      }
    }

    &__controls {
      margin: 1em 0 2.5em;
      flex: 1 1 auto;
      width: 100%;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__summary {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      align-content: space-between;
      align-items: flex-start;

      &-header {
        flex: none;
        width: 100%;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 21px;
      }

      &-amount {
        flex: none;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
      }

      &-price {
        flex: none;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
</style>
